"use client"

import { Hand } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `HandIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const HandIcon = component(Icon)({ as: Hand })
